// extracted by mini-css-extract-plugin
export default {"head":"Header_head__-lYG7"};